module.exports = __webpack_public_path__ + "static/project-tweets-c474c354673123e85f1e5fc0a5bf2820.png";